import { atom } from "jotai";

import { BookingWizard } from "../../../types";
import {
  BookingWizardDataAtom,
  CurrentRequestGroupIndexAtom,
  ListOfBookingWizardStepsAtom,
  originalListOfBookingWizardStepsAtom,
} from "../../stores";

/** Updates the selected aggregate-request group count and wizard steps. */
export const setRequestGroupCountAtom = atom(
  null,
  (get, set, count: number) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (bookingWizardData?.type !== "RequestBooking") {
      return;
    }

    const maxGroupCount = bookingWizardData.maxRequestGroupCount ?? 1;
    const requestGroupCount = Math.min(Math.max(count, 1), maxGroupCount);
    const currentGroupIndex = get(CurrentRequestGroupIndexAtom);
    const rounds = bookingWizardData.rounds.filter(
      (round) => (round.bookingIndex ?? 0) < requestGroupCount
    );

    set(BookingWizardDataAtom, {
      ...bookingWizardData,
      requestGroupCount,
      rounds,
    });
    set(
      CurrentRequestGroupIndexAtom,
      Math.min(currentGroupIndex, requestGroupCount - 1)
    );

    const currentSteps = get(ListOfBookingWizardStepsAtom);
    const originalSteps = get(originalListOfBookingWizardStepsAtom);
    const playerStep: BookingWizard.BookingWizardStepTitle =
      bookingWizardData.isPrivate ? "AddPlayersPrivate" : "AddPlayers";

    if (requestGroupCount > 1 && !currentSteps.includes(playerStep)) {
      set(ListOfBookingWizardStepsAtom, [...currentSteps, playerStep]);
    } else if (
      requestGroupCount === 1 &&
      !originalSteps.includes(playerStep) &&
      currentSteps.includes(playerStep)
    ) {
      set(
        ListOfBookingWizardStepsAtom,
        currentSteps.filter((step) => step !== playerStep)
      );
    }
  }
);
